export default __webpack_public_path__ + "static/media/energy_unselected.55c6e238.svg";